import React from 'react';
import { clients } from '../../utils/data';
import styled from 'styled-components';


const Clients = () => {

    return (
        <>
            <StyledClients >
                <div className="container">

                    <div className="col-md-7 mx-auto">
                        <h4 className='pry-text mb-4'>
                            Join 600+ successful business owners  who make use of Reni.finance for their business management needs
                        </h4>
                    </div>
                    <div className="d-flex justify-content-between mt-5">
                        {clients.map((item, i) => {
                            return (
                                <div className="d-flex gap-3 mb-4" key={i}>
                                    <img src={item} alt="Client" width="100px" />
                                </div>
                            );
                        })}
                    </div>

                </div>
            </StyledClients>

        </>
    );
};

export default Clients;


const StyledClients = styled.section`
    
padding: 4rem 0;
margin: 4rem 0;
background-color: var(--sec-bold-color);

`;